import api from '../utils/api';

const BUSINESS_ID = process.env.REACT_APP_BUSINESS_ID;

export const getCourses = (params) => {
  return api.get(`/businesses/${BUSINESS_ID}/courses`, { params });
};

export const getCourseBySlug = (slug) => {
  return api.get(`/businesses/${BUSINESS_ID}/courses/${slug}`);
};

export const enrollInCourse = (courseId, data) => {
  return api.post(`/courses/${courseId}/enroll`, data);
};
